import React, { useState } from "react";
import Section from "../../Section";
import bestLocation from "../../../assest/GreenHome/images/bestLocation.jpg";

import List from "./List";
import {
  greenHomeOutterRenderPaths,
  innerRenderPaths,
} from "../../../assest/imgPaths";

const ProjectWhySection = () => {
  const [activeImg, setActiveImg] = useState(1);

  const onHoverHandler = (number) => {
    setActiveImg(number);
  };

  return (
    <Section bg="bg-primary-bg-blue/90">
      <div
        data-v-08671491=""
        id="w-node-_0fb033b0-5a5d-3ec8-4959-b379dd738f4a-0a6b3cff"
        className="col-span-10 col-start-2  grid grid-cols-9 gap-5 py-16 text-primary-bg-blue xl:min-h-[594px] 2xl:min-h-[794px]"
      >
        {/* სურათი */}
        <div
          data-v-08671491=""
          className="hidden xl:block h-full col-start-1 col-span-4"
        >
          <div data-v-08671491="" className="h-full ">
            {activeImg === 1 && (
              <img
                data-v-08671491=""
                src={bestLocation}
                loading="lazy"
                data-nuxt-img=""
                className="h-auto w-full object-cover transition-all animate-fadeIn rounded-2xl"
                alt="K2 Invest Group"
              />
            )}
            {activeImg === 2 && (
              <img
                data-v-08671491=""
                src={greenHomeOutterRenderPaths.photo1}
                loading="lazy"
                data-nuxt-img=""
                className="h-full w-full object-cover transition-all animate-fadeIn rounded-2xl-"
                alt="K2 Invest Group"
              />
            )}
            {activeImg === 3 && (
              <img
                data-v-08671491=""
                src={greenHomeOutterRenderPaths.photo2}
                loading="lazy"
                data-nuxt-img=""
                className="h-full w-full object-cover transition-all animate-fadeIn rounded-2xl"
                alt="K2 Invest Group"
              />
            )}
            {activeImg === 4 && (
              <img
                data-v-08671491=""
                src={innerRenderPaths[4]}
                loading="lazy"
                data-nuxt-img=""
                className="h-full w-full object-cover transition-all animate-fadeIn rounded-2xl"
                alt="K2 Invest Group"
              />
            )}
          </div>
        </div>
        {/* ჩამონათვალი */}
        <div
          data-v-08671491=""
          className="max-h-fit xl:col-start-5 col-span-7 xl:col-span-6 tracking-wider text-2xl xl:text-4xl xl:px-16 text-primary-light"
        >
          <h2 className="font-gilroy">რატომ K2 ავტომშენებელზე?</h2>
          <div className="w-full h-[2px] bg-primary-bg-blue/70 my-8" />
          <List activeImg={activeImg} onHoverHandler={onHoverHandler} />
        </div>
      </div>
    </Section>
  );
};

export default ProjectWhySection;
